var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPulse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.36 17.2194C27.36 17.3275 27.3352 17.4303 27.2882 17.5195L22.4501 25.9801C22.2449 26.339 21.8657 26.56 21.4554 26.56H10.7046C10.2942 26.56 9.91505 26.339 9.70986 25.9801L4.87135 17.5187C4.82447 17.4296 4.79999 17.3273 4.79999 17.2194C4.79999 16.8692 5.08116 16.5853 5.428 16.5853H10.7363L12.0815 18.8924L12.0898 18.9061C12.2693 19.1972 12.647 19.292 12.9413 19.1171L12.9565 19.1077C13.0922 19.0218 13.1905 18.8865 13.2307 18.7295L14.9448 12.039L16.4167 22.8103L16.4189 22.8253C16.4733 23.1641 16.786 23.3989 17.1246 23.3517L17.14 23.3494C17.3852 23.309 17.5843 23.1262 17.6468 22.8824L19.713 14.818L20.5613 16.2729L20.5697 16.2869C20.6842 16.4722 20.8855 16.5853 21.1025 16.5853H26.732C27.0788 16.5853 27.36 16.8692 27.36 17.2194ZM21.4554 5.44C21.8657 5.44 22.2449 5.66104 22.4501 6.01986L27.2885 14.4809C27.3353 14.57 27.36 14.6727 27.36 14.7806C27.36 15.1308 27.0788 15.4147 26.732 15.4147H21.4063L20.0611 13.1077L20.0518 13.0923C19.9667 12.9553 19.8327 12.8561 19.6772 12.8155L19.6626 12.8118C19.3315 12.7337 18.9975 12.9364 18.9119 13.2705L17.1977 19.961L15.7259 9.18973L15.7236 9.1742C15.6836 8.92668 15.5025 8.72558 15.2611 8.66253C14.9253 8.57483 14.5826 8.77857 14.4958 9.11759L12.4296 17.182L11.5813 15.7271L11.5728 15.7131C11.4584 15.5278 11.2571 15.4147 11.0401 15.4147H5.428C5.08116 15.4147 4.79999 15.1308 4.79999 14.7806C4.79999 14.6736 4.82381 14.5723 4.86983 14.4838L9.70986 6.01986C9.91505 5.66104 10.2942 5.44 10.7046 5.44H21.4554Z",
    fill: "url(#paint0_linear_2175_30)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2175_30",
    x1: 21.925,
    y1: 5.80934,
    x2: 9.5313,
    y2: 26.9762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326385,
    stopColor: "#354AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680558,
    stopColor: "#DE18E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9073A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulse);
export default __webpack_public_path__ + "static/media/pulse.356589ae68213c7da1ba9948f97684ad.svg";
export { ForwardRef as ReactComponent };